
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import { ModalState } from '@/core/types/modal-state';
import { ProfileAPIService } from '@/profile/services/api';
import {
	ConfirmValidation, newPasswordRules, confirmPasswordRules,
} from '@kasasa/kloans-common-ui/dist/validations';
import { Alert } from '@/core/types/alert';
import { AlertTypeEnum } from '@/core/types/alert-type-enum';
import { CoreHelper } from '@/core/helper';

const EDIT_PASSWORD_SUCCESS_MESSAGE = 'Password Successfully Updated';

@Component({
	validations: {
		password: newPasswordRules.validations,
		passwordConfirmation: confirmPasswordRules.validations,
	},
})
export default class ProfileEditPasswordModal extends Vue {
	public alert: Alert | null = null;

	public isLoading = false;

	public isShown = false;

	public oldPassword = '';

	public password = '';

	public passwordConfirmation = '';

	@Prop({ default: { isShown: false } })
	public state!: ModalState;

	public wasChangeSuccessful = false;

	@Watch('state')
	public watchState(state: { isShown: boolean }): void {
		this.isShown = state.isShown;
	}

	get passwordConfirmationErrors(): string[] {
		return ConfirmValidation.errors(this, 'passwordConfirmation', 'password');
	}

	get passwordErrors(): string[] {
		return newPasswordRules.errors(this);
	}

	async changePassword() {
		this.$v.$touch();

		if (this.$v.$invalid) {
			return;
		}

		this.isLoading = true;
		this.wasChangeSuccessful = false;

		try {
			await ProfileAPIService.changePassword({
				oldPassword: this.oldPassword,
				newPassword: this.password,
			});

			this.wasChangeSuccessful = true;

			this.alert = {
				type: AlertTypeEnum.SUCCESS,
				message: EDIT_PASSWORD_SUCCESS_MESSAGE,
			};
		} catch (error) {
			console.error(error);

			this.alert = {
				type: AlertTypeEnum.ERROR,
				message: CoreHelper.getHttpErrorMessage(error),
			};
		}

		this.isLoading = false;
	}

	public close(): void {
		this.isShown = false;
		this.reset();
	}

	private reset(): void {
		this.alert = null;
		this.isLoading = false;
		this.oldPassword = '';
		this.password = '';
		this.passwordConfirmation = '';
		this.wasChangeSuccessful = false;
		this.$v.$reset();
	}
}
